import { AxiosResponse } from 'axios';
import { minutesToMilliseconds } from 'date-fns';
import _ from 'lodash';
import { useQuery } from 'react-query';
import { queryClient } from 'src/config/react-query';
import { useAuth } from 'src/contexts/JWTContext';
import { getPublicIcons } from 'src/services/icons';
import { Icon, IconTypes, ImageIconOption } from 'src/types/icons';

export const formatOutgoingIcon = (icon: Icon) => ({
  type: icon.type,
  value: icon.type === IconTypes.IMAGE ? icon.value.split('?')[0] : icon.value,
});

export const getIcons = () =>
  (queryClient.getQueryData('icons') as AxiosResponse<ImageIconOption[]>)?.data;

// we need 'icons' to have initial data so we can get a random icon on each formatDefaultIcon() call
// we need 'icons' to be refetched every 5 mins so the URLs don't expire
export const useIconsRefetch = () => {
  const { instance } = useAuth();

  useQuery('icons', getPublicIcons, {
    enabled: !!instance,
    refetchInterval: minutesToMilliseconds(5),
  });

  return !instance || getIcons();
};

export const formatDefaultIcon = (icon?: Icon) => {
  const icons = getIcons();

  return {
    type: icon?.type || IconTypes.IMAGE,
    value: icon?.value || _.sample(icons).source,
  };
};
